export default __webpack_public_path__ + "static/media/portofolio.69d0b2cb.jpg";